import withAPIAction from 'helpers/withAPIAction'
import { ReturnListReq, CreateReturnReq, UpdateReturnReq, DeleteReturnReq, ReturnDetailReq } from './types'
import {
  getReturnListAction,
  createReturnAction,
  updateReturnAction,
  deleteReturnAction,
  getReturnDetailAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'

export const returnListAPI = (data: ReturnListReq, token: string, xmid: any) => {
  return withAPIAction<ReturnListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.returnList}`,
    data,
    token,
    xmid,
    // hideOath: true,
  })(getReturnListAction)
}

export const createReturnOrderAPI = (data: CreateReturnReq, token: string, xmid: any) => {
  return withAPIAction<CreateReturnReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.createReturnOrder,
    data,
    token,
    xmid,
  })(createReturnAction)
}

export const updateReturnStatusAPI = (data: UpdateReturnReq, token: string, xmid: any) => {
  const endPoint = APIPath.updateReturnStatus.replace(':id', data.id.toString())
  return withAPIAction<UpdateReturnReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(updateReturnAction)
}

export const deleteReturnAPI = (data: DeleteReturnReq, token: string, xmid: any) => {
  const endPoint = APIPath.deleteReturn.replace(':id', data.id.toString())
  return withAPIAction<DeleteReturnReq>({
    method: 'DELETE',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(deleteReturnAction)
}

export const getReturnDetailAPI = (data: ReturnDetailReq, token: string, xmid: any) => {
  const endPoint = APIPath.getReturnByID.replace(':id', data.id.toString())
  return withAPIAction<ReturnDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(getReturnDetailAction)
}
